<!-- Content -->
@if (form) {
  <medsurf-design-form-control-form
    [formGroup]="form"
    [class]="'w-full'"
    (onSubmit)="onChange()">
    <div medsurf-design-content-input-group>
      <!-- Solution -->
      <medsurf-design-form-control-input-dropdown [formField]="false"
        [class]="'w-full'"
        [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.DEFAULT"
        [menuClass]="FlatModels.PanelDesignModels.MenuDesignClass.WHITE"
        [control]="form.controls.solution"
        [options]="choices"
        [optionLabel]="'label'"
        [optionValue]="'order'"
        (valueChange)="onChange()">
      </medsurf-design-form-control-input-dropdown>
      <!-- Delete -->
      <button medsurf-design-input-button [id]="'mapping_solution_remove'"
        [title]="'global.solution_remove' | translate"
        [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.DANGER_FUllHEIGHT"
        [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.REMOVE"
      (click)="removeSolution()"></button>
    </div>
  </medsurf-design-form-control-form>
}
